import * as React from "react";
import ToolBarItem from "modules/project/components/layouts/ToolBarItem";
import { observer } from "mobx-react";
import {
  Cut,
  Copy,
  Paste,
  InsertRowAbove,
  InsertRowBelow,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
} from "common/icons";
import { withStyles } from "@material-ui/core/styles";
import { Delete, Search } from "@material-ui/icons";
import { ModelMapStore } from "modules/modelMap/ModelMapStore";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";

const styles = (theme) => ({
  container: {
    height: "33px",
    display: "flex",
    backgroundColor: "#000",
    flexFlow: "row nowrap",
    position: "relative" as any,
  },
});

type IProps = {
  classes: any;
};

@observer
class ToolBarTakeOffFormat extends React.Component<IProps> {
  render() {
    let { classes } = this.props;
    let borderLeft = "1px solid #595959";
    let borderRight = "1px solid #595959";
    return (
      <div className={classes.container}>
        <ToolBarItem
          Icon={Cut}
          action={() => {}}
          fontSize={15}
          styles={{ borderLeft }}
          disabled={true}
        />

        <ToolBarItem
          Icon={Copy}
          action={() => {}}
          fontSize={16}
          disabled={true}
        />

        <ToolBarItem
          Icon={Paste}
          action={() => {}}
          fontSize={16}
          disabled={true}
        />

        <ToolBarItem
          Icon={InsertRowBelow}
          fontSize={21}
          styles={{ borderLeft }}
          disabled={!TakeOffStore.arrowEnable()}
          action={() => {
            ModelMapStore.addNewFormatLine(-1);
          }}
        />

        <ToolBarItem
          Icon={InsertRowAbove}
          fontSize={21}
          disabled={!TakeOffStore.arrowEnable()}
          action={() => {
            ModelMapStore.addNewFormatLine(1);
          }}
        />

        <div style={{ display: "flex", alignItems: "center" }}>
          <ToolBarItem
            Icon={Delete}
            action={() => {}}
            fontSize={19}
            disabled={true}
          />
        </div>

        <ToolBarItem
          Icon={ArrowLeft}
          styles={{ borderLeft }}
          disabled={!TakeOffStore.arrowEnable()}
          action={() => {
            ModelMapStore.detachFormatLine();
          }}
        />

        <ToolBarItem
          Icon={ArrowRight}
          styles={{ borderRight }}
          disabled={!TakeOffStore.arrowEnable()}
          action={() => {
            ModelMapStore.attachFormatLine();
          }}
        />

        <ToolBarItem
          Icon={ArrowUp}
          action={() => {}}
          styles={{ borderLeft }}
          disabled={true}
        />

        <ToolBarItem Icon={ArrowDown} action={() => {}} disabled={true} />

        <div style={{ display: "flex", alignItems: "center" }}>
          <ToolBarItem
            style={{ height: "100%" }}
            Icon={Search}
            action={() => {}}
            fontSize={20}
            styles={{ borderLeft }}
            disabled={true}
          />
        </div>
      </div>
    );
  }
}
export default withStyles(styles)(ToolBarTakeOffFormat);



// WEBPACK FOOTER //
// ./src/modules/project/components/layouts/ToolBarTakeOffFormat.tsx